import { embedFilter } from '../sharedFilters'

const DATASET_KEY = 'security_managment_risk_assessment'

export default {
  key: 'security_managment_risk_assessment',
  label: 'GSMS - Risk Assessment',
  timeColumn: 'security_managment_risk_assessment.actual_date',
  permission: { action: 'reporting', subject: 'Widget' },

  tables: {
    security_managment_risk_assessment: ["id", "risk_assessment_id", "building_code", "assessment_type", "assessment_status", "scheduled_date", "target_date", "actual_date", "revised_risk_score", "inherent_risk_level", "residual_risk_level", "actual_vs_target", "actual_vs_retargeted", "assigned_assessor", "last_assessment_date", "approvals_status", "is_unscheduled", "unscheduled_reason", "is_assessor_notified", "is_assessor_approved", "risk_change_explanation", "description_of_controls", "business_contact_name", "business_contact_date", "created_at", "updated_at"],
    security_managment_facility: ["id", "facility_id", "csis_building_status", "crs_building_status", "region", "country", "state", "city", "zip", "address", "building_code", "facility_name", "floor_code", "occupied", "has_data_center", "has_child_care", "number_of_floors", "occupied_floors", "owned_or_leased", "vacancy_date", "headcount", "updated_headcount", "primary_facility_type", "source_instance", "created_at", "updated_at"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'security_managment_risk_assessment',
    columns: 'security_managment_facility.building_code,security_managment_facility.facility_name,security_managment_facility.address,security_managment_facility.city,security_managment_facility.state,security_managment_facility.country,security_managment_facility.primary_facility_type,security_managment_facility.csis_building_status',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'security_managment_facility.building_code', label: 'Instalacion' },
    { key: 'security_managment_facility.facility_name', label: 'Nombre instalacion' },
    { key: 'security_managment_facility.address', label: 'Direccion' },
    { key: 'security_managment_facility.city', label: 'Ciudad' },
    { key: 'security_managment_facility.state', label: 'Estado' },
    { key: 'security_managment_facility.country', label: 'Pais' },
    { key: 'security_managment_facility.primary_facility_type', label: 'Tipo instalacion' },
    { key: 'security_managment_facility.csis_building_status', label: 'Estatus CSIS' },
    { key: 'security_managment_risk_assessment.assessment_status', label: 'Estatus' },
    { key: 'security_managment_risk_assessment.assigned_assessor', label: 'Evaluador' },
    { key: 'security_managment_risk_assessment.risk_assessment_id', label: 'Referencia' },
    { key: 'security_managment_risk_assessment.assessment_type', label: 'Tipo' },
    { key: 'security_managment_risk_assessment.revised_risk_score', label: 'Nivel' },
    { key: 'security_managment_risk_assessment.actual_date', label: 'Fecha', defaultParams: { freq: '1mo' } },
  ],

  filters: [
    embedFilter(DATASET_KEY, 'security_managment_facility.building_code', 'Instalacion', 'installation'),
    embedFilter(DATASET_KEY, 'security_managment_facility.facility_name', 'Nombre instalacion', 'facility_name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.city', 'Ciudad', 'city'),
    embedFilter(DATASET_KEY, 'security_managment_facility.country', 'Pais', 'country'),
    embedFilter(DATASET_KEY, 'security_managment_risk_assessment.assessment_status', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'security_managment_risk_assessment.assigned_assessor', 'Evaluador', 'name'),
    embedFilter(DATASET_KEY, 'security_managment_facility.state', 'Estado', 'group'),
    embedFilter(DATASET_KEY, 'security_managment_risk_assessment.risk_assessment_id', 'Referencia', 'reference'),
    embedFilter(DATASET_KEY, 'security_managment_risk_assessment.assessment_type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'security_managment_risk_assessment.revised_risk_score', 'Nivel', 'level'),
  ],

    dateGrouping: {
    column: 'security_managment_risk_assessment.actual_date',
    presets: [
      { value: '1d', label: 'Dia' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Anio' },
    ],
  },
}
